/** Per-user journal session index: `users/{uid}/journalSessions/{sessionId}` */
export const COLLECTION_JOURNAL_SESSIONS = 'journalSessions';
